import * as tslib_1 from "tslib";
import { isDevMode, OnInit, } from '@angular/core';
import { FormBuilder, Validators, } from '@angular/forms';
import { ActivatedRoute, Router, } from '@angular/router';
import { AppStateFacade } from '@app-state';
import { PageMetadataRegistry } from '@app/router';
import { UpsertPageComponent, } from '@components';
import { FeatureFlag, QueueJsonSchema, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { MAX_NUMBER_OF_RESULTS } from '@pages/shared/constants';
import { ProcessService, QueueItemService, } from '@services';
import { UiSnackBarService } from '@uipath/angular/components/ui-snackbar';
import UiValidators, { UI_DESCRIPTION_SHORT_MAX_LENGTH } from '@validators';
import { BehaviorSubject, of, } from 'rxjs';
import { finalize, switchMap, takeUntil, tap, } from 'rxjs/operators';
import { UPSERT_QUEUE_FIELDS } from './queue.upsert.page.models';
import { QueueUpsertPageService } from './queue.upsert.page.service';
import { UiTimeOffsetPickerComponent } from './ui-time-offset-picker/ui-time-offset-picker.component';
var RiskSlaLessThanSla = function (control) {
    var sla = control.get('slaMinutes');
    var riskSla = control.get('riskSlaMinutes');
    if (sla !== null &&
        riskSla !== null &&
        !sla.disabled &&
        !riskSla.disabled &&
        riskSla.value > sla.value) {
        var error = riskSla.errors || {};
        error.greaterThanSla = true;
        riskSla.setErrors(error);
        return error;
    }
    return null;
};
var ɵ0 = RiskSlaLessThanSla;
var DEFAULT_TIME_OFFSET_RANGE = {
    min: 0,
    max: 90,
};
var QueueUpsertPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(QueueUpsertPageComponent, _super);
    function QueueUpsertPageComponent(_route, _router, _appState, _fb, _snack, _upsertService, _translate, _process, _pageRegistry, _queueItem) {
        var _this = _super.call(this, _route, _router, _appState) || this;
        _this._fb = _fb;
        _this._snack = _snack;
        _this._upsertService = _upsertService;
        _this._translate = _translate;
        _this._process = _process;
        _this._pageRegistry = _pageRegistry;
        _this._queueItem = _queueItem;
        _this.QueueJsonSchema = QueueJsonSchema;
        _this.fields = UPSERT_QUEUE_FIELDS;
        _this.isDevMode = isDevMode();
        _this.isQueueSchemaDefinitionsEnabled = _this._appState.settings.isFeatureEnabled(FeatureFlag.QueueSchemaDefinitions);
        _this.isQueueSlaMonitoringEnabled = _this._appState.settings.isFeatureEnabled(FeatureFlag.QueueSlaMonitoring);
        _this.reading$ = new BehaviorSubject(false);
        _this.slaEnabled$ = new BehaviorSubject(false);
        _this.riskSlaEnabled$ = new BehaviorSubject(false);
        _this.triggerIsDefined = false;
        _this.hasQueueItems = false;
        _this.isProcessViewGranted$ = _this._appState.user.permissions.isGranted('Processes.View');
        _this._isTransactionsViewGranted$ = _this._appState.user.permissions.isGranted('Transactions.View');
        _this._dirtyStatus = true;
        _this._initialSlaValue = 0;
        _this.processSearchFactory = function (query, step, skip) {
            if (query === void 0) { query = ''; }
            if (step === void 0) { step = MAX_NUMBER_OF_RESULTS; }
            if (skip === void 0) { skip = 0; }
            return _this._process.suggest(query, step, skip);
        };
        _this.getProcess = function (id) { return _this._process.getInstance(id); };
        _this._getInstance = function () {
            return _this._upsertService.getInstance(_this.id);
        };
        return _this;
    }
    Object.defineProperty(QueueUpsertPageComponent.prototype, "defaults", {
        get: function () {
            return {
                name: '',
                description: '',
                enforceUniqueReference: {
                    value: false,
                    disabled: this.isEditMode,
                },
                acceptAutoRetry: {
                    value: true,
                    disabled: this.isEditMode,
                },
                maxNoOfRetries: 1,
                specificDataJsonSchema: '',
                outputDataJsonSchema: '',
                analyticsDataJsonSchema: '',
                slaMinutes: 60,
                riskSlaMinutes: 60,
                triggerId: null,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QueueUpsertPageComponent.prototype, "validators", {
        get: function () {
            return {
                name: Validators.compose([
                    Validators.required,
                    UiValidators.whitespace,
                    Validators.maxLength(50),
                ]),
                maxNoOfRetries: this.isEditMode ? [] : UiValidators.range(1, 50),
                description: Validators.maxLength(UI_DESCRIPTION_SHORT_MAX_LENGTH),
                releaseId: UiValidators.required(),
                releaseKey: UiValidators.required(),
                // 1 hour to 90 days, separate min/max for UiTimeOffSetPicker errors
                slaMinutes: Validators.compose([
                    Validators.min(60),
                    Validators.max(60 * 24 * 90),
                ]),
                riskSlaMinutes: Validators.compose([
                    Validators.min(60),
                    Validators.max(60 * 24 * 90),
                ]),
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QueueUpsertPageComponent.prototype, "slaErrorsToCheck", {
        get: function () {
            return [
                {
                    error: 'greaterThanSla',
                    errorMessage: this._translate.instant('queue_risk_sla_less_than_sla_error'),
                },
                {
                    error: 'min',
                    errorMessage: this._translate.instant('time_offset_days_range_warning', DEFAULT_TIME_OFFSET_RANGE),
                },
                {
                    error: 'max',
                    errorMessage: this._translate.instant('time_offset_days_range_warning', DEFAULT_TIME_OFFSET_RANGE),
                },
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QueueUpsertPageComponent.prototype, "_submit$", {
        get: function () {
            if (!this.form) {
                throw new Error('Form is undefined');
            }
            var formValues = tslib_1.__assign({}, this.form.getRawValue(), (this.form.value.acceptAutoRetry === false ?
                { maxNoOfRetries: 0 } :
                {}));
            // we should only clear releaseId if there is no trigger
            if (!this.triggerIsDefined && this.form.get('releaseId').disabled) {
                delete formValues['releaseId'];
            }
            if (this.form.get('slaMinutes').disabled) {
                delete formValues['slaMinutes'];
            }
            if (this.form.get('riskSlaMinutes').disabled) {
                delete formValues['riskSlaMinutes'];
            }
            return this.isEditMode ?
                this._upsertService.update(this.id, formValues) :
                this._upsertService.add(formValues);
        },
        enumerable: true,
        configurable: true
    });
    QueueUpsertPageComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (this.isEditMode) {
            this._appState.user.folder
                .change$.pipe(tap(this._forceNavigateBaseUrl), takeUntil(this._destroyed$)).subscribe();
        }
    };
    QueueUpsertPageComponent.prototype.onAutoRetryOptionChange = function (enabled) {
        var maxNoOfRetries = this.getField('maxNoOfRetries');
        maxNoOfRetries[enabled ? 'enable' : 'disable']();
    };
    QueueUpsertPageComponent.prototype.onEnforceUniqueReferenceChange = function () {
        var enforceUnique = this.getField('enforceUniqueReference');
        enforceUnique.setValue(!enforceUnique.value);
    };
    QueueUpsertPageComponent.prototype.onReading = function (value) {
        this.reading$.next(value);
    };
    QueueUpsertPageComponent.prototype.onSlaToggle = function (state) {
        this.slaEnabled$.next(state.checked);
    };
    QueueUpsertPageComponent.prototype.onRiskSlaToggle = function (state) {
        this.riskSlaEnabled$.next(state.checked);
    };
    QueueUpsertPageComponent.prototype.onProcessSelected = function (event) {
        this.getField('releaseId').setValue(event ? event.id : undefined);
    };
    QueueUpsertPageComponent.prototype.submit = function () {
        var _this = this;
        if (this.isSubmitDisabled) {
            return;
        }
        this.loading$.next(true);
        this._submit$.pipe(finalize(function () {
            _this._ignoreDirtyStatus = _this._dirtyStatus;
            _this.loading$.next(false);
        })).subscribe(function () {
            _this._snack.success(_this._translate.instant('save_successful'));
            _this._forceNavigateBaseUrl();
        }, function (error) {
            if (error.status === 403) {
                _this._forceNavigateBaseUrl();
            }
            _this._dirtyStatus = false;
        });
    };
    QueueUpsertPageComponent.prototype._initForm = function (config, _, queue) {
        var _this = this;
        this.form = this._fb.group(config, { validator: RiskSlaLessThanSla });
        if (queue) {
            this.slaEnabled$.next(queue.slaMinutes > 0);
            this.riskSlaEnabled$.next(queue.riskSlaMinutes > 0);
            this._pageRegistry.setCustomTitle(queue.name);
            this.triggerIsDefined = !!queue.releaseId && !!queue.triggerId;
            this._queueItemsExist(queue.id);
            if (queue.releaseId) {
                this.isProcessViewGranted$
                    .pipe(switchMap(function (isGranted) { return isGranted ?
                    _this.getProcess(queue.releaseId) : of(null); }), takeUntil(this._destroyed$)).subscribe(function (release) {
                    if (release) {
                        _this.getField('releaseKey').setValue([{ id: release.id, text: release.name }]);
                    }
                });
            }
        }
        this._setupSlaSubscriptions();
        this.loading$.next(false);
    };
    QueueUpsertPageComponent.prototype._queueItemsExist = function (id) {
        var _this = this;
        if (!id) {
            return;
        }
        var queryOptions = {
            top: 1,
            filter: {
                QueueDefinitionId: {
                    eq: id,
                },
            },
        };
        this._isTransactionsViewGranted$
            .pipe(switchMap(function (isGranted) { return isGranted ?
            _this._queueItem.get(queryOptions) : of(null); }), takeUntil(this._destroyed$)).subscribe(function (item) {
            if (item && item.data && item.data.length > 0) {
                _this.hasQueueItems = true;
            }
        });
    };
    QueueUpsertPageComponent.prototype._setupSlaSubscriptions = function () {
        var _this = this;
        this._initialSlaValue = this.getField('slaMinutes').value;
        this.slaEnabled$
            .pipe(takeUntil(this._destroyed$)).subscribe(function (enabled) {
            var releaseId = _this.getField('releaseId');
            enabled ? releaseId.enable() : releaseId.disable();
            var releaseKey = _this.getField('releaseKey');
            enabled ? releaseKey.enable() : releaseKey.disable();
            var slaMinutes = _this.getField('slaMinutes');
            enabled ? slaMinutes.enable() : slaMinutes.disable();
            if (!enabled) {
                _this.riskSlaEnabled$.next(false);
            }
            if (enabled && slaMinutes.value === 0) {
                slaMinutes.setValue(60);
            }
            else if (!enabled) {
                // clear all values on disable
                slaMinutes.setValue(0);
                if (!_this.triggerIsDefined) {
                    releaseKey.setValue([]);
                    releaseId.setValue(undefined);
                }
            }
            if (_this._initialSlaValue !== slaMinutes.value) {
                slaMinutes.markAsDirty();
            }
        });
        this.riskSlaEnabled$
            .pipe(takeUntil(this._destroyed$)).subscribe(function (enabled) {
            var riskSlaMinutes = _this.getField('riskSlaMinutes');
            enabled ? riskSlaMinutes.enable() : riskSlaMinutes.disable();
            // to handle edit scenarios where the value is already set
            if (enabled && riskSlaMinutes.value === 0) {
                var slaMinutesValue = _this.getField('slaMinutes').value;
                // riskSlaValue should be 75% of slaValue by default
                riskSlaMinutes.setValue(Math.ceil((slaMinutesValue * .75) / 60) * 60);
            }
            else if (!enabled) {
                riskSlaMinutes.setValue(0);
            }
            _this.form.markAsDirty();
        });
        // required to update validity of risk SLA based on SLA
        this.getField('slaMinutes')
            .valueChanges.pipe(takeUntil(this._destroyed$)).subscribe(function (_) {
            _this.getField('riskSlaMinutes').updateValueAndValidity();
            if (!_this.riskSlaTimeOffsetComponent) {
                return;
            }
            _this.riskSlaTimeOffsetComponent.form.get('days').updateValueAndValidity();
            _this.riskSlaTimeOffsetComponent.form.get('hours').updateValueAndValidity();
        });
    };
    return QueueUpsertPageComponent;
}(UpsertPageComponent));
export { QueueUpsertPageComponent };
export { ɵ0 };
